<template>
  <v-card class="mx-1" v-if="!homePage()">
    <v-row no-gutters class="d-flex align-center mt-8 mb-6">
      <v-col cols="10" class="d-flex justify-start">
        <v-breadcrumbs
            :items="breadcrumbsGen">
          <template v-slot:divider >
            <v-icon size="22">mdi-chevron-right</v-icon>
          </template>
          <template v-slot:item="{ item }">
            <router-link :to="item.to" class="font-weight-regular">
              <v-breadcrumbs-item>
                {{ item.text }}
              </v-breadcrumbs-item>
            </router-link>

            <v-breadcrumbs-item :href="item.to" link class="text-capitalize" v-if="0">
              {{ item.text }}
            </v-breadcrumbs-item>
          </template>
        </v-breadcrumbs>
      </v-col>
      <v-col cols="2" class="d-flex justify-end">
        <GoBack />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import GoBack from "@/components/Breadcrumbs/GoBack";
export default {
  components: {
    GoBack
  },
  computed: {
    breadcrumbsGen() {
      let breadcrumbs = []
      
      breadcrumbs = this.$route.matched.reduce((breadcrumbArray, route) => {
        let path = route.path
        if(this.$route.params.projetoId) {
          path = path.replace(new RegExp(":projetoId", "g"), this.$route.params.projetoId)          
        }
        if(this.$route.params.logicaIntervencaoId) {
          path = path.replace(new RegExp(":logicaIntervencaoId", "g"), this.$route.params.logicaIntervencaoId)          
        }
        if(this.$route.params.indicadorId) {          
          path = path.replace(new RegExp(":indicadorId", "g"), this.$route.params.indicadorId)
        }
        
        breadcrumbArray.push({
          text: route.meta.breadCrumbName,
          to: path
        })
        return breadcrumbArray;
      }, [])
      
      breadcrumbs.unshift({text: 'Início', to: '/inicio'});

      if(typeof breadcrumbs[breadcrumbs.length-1].text === 'undefined') {
        breadcrumbs.pop()
      }

      return breadcrumbs;
    }
  },
  methods: {
    homePage() {
      return this.$route.path === "/" || this.$route.path === "/inicio";
    },
  },
}
</script>

<style src="./Breadcrumbs.scss" lang="scss"></style>